export const updateStampaProposal = (unDato, unActionType) => {
  return {
    type: unActionType,
    unDato,
  }
};
